export default {
    questionType: {
        plainText: 'Plain Text',
        yesOrNo: 'Yes or No',
        ratingScale: 'Rating Scale',
        multipleChoices: 'Multiple Choices',
        checkBoxes: 'Checkboxes',
        smileyOptions: 'Smiley Options',
        sectionTitle: 'Section Title',
        rankingQuestion: 'Ranking',
    },
};
